<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="proveedores" :search="search" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editProveedor(item.cod_proveedor)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.nombre }}
                    ({{ itemToDelete.ref }})
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar el Proveedor?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteProveedor(itemToDelete.cod_proveedor)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import ProveedoresDataService from "@/services/ProveedoresDataService";

export default {
    name: "ProveedoresList",
    data: () => ({
        proveedores: [],
        search: '',
        sortBy: 'ref',
        sortDesc: false,
        headers: [
            { text: 'Referencia', value: 'ref' },
            { text: 'Nombre', value: 'nombre' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveProveedores() {
            ProveedoresDataService.getAll()
                .then((response) => {
                    // console.log("PROVEEDORES"); console.log(response.data);
                    this.proveedores = response.data.map(this.getDisplayProveedor);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editProveedor(id) {
            this.$router.push({ name: "ProveedorId", params: { id: id } });
        },
        deleteProveedor(id) {
            ProveedoresDataService.delete(id)
                .then(() => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.retrieveProveedores();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        getDisplayProveedor(proveedor) {
            return {
                cod_proveedor: proveedor.cod_proveedor,
                ref: proveedor.referencia,
                nombre: proveedor.nombre,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveProveedores();
    }
};
</script>